































































import {Component, Vue} from 'vue-property-decorator';
import {ElForm} from "element-ui/types/form";
import axios from 'axios';

@Component({
  components: {},
})
export default class DemanderJoin extends Vue {

  title = '';
  type = '';
  loading = false;
  form = {
    corpname: '', // 企业名称
    staffSize: '', // 人员规模
    contacter: '', //联系人
    telephone: '', //联系电话
    business: '', // 主营业务
    reason: '', // 申请理由
    applyType: 0
  };
  formResult: 'success' | 'fail' | '' = ''

  rules = {
    corpname: [
      {required: true, message: '请输入企业名称', trigger: 'change'},
      {max: 50, message: '长度在50个字符内', trigger: 'change'}
    ],
    staffSize: [
      {required: true, message: '请选择人员规模', trigger: 'change'}
    ],
    business: [
      {required: true, message: '请输入主营业务', trigger: 'change'},
      {max: 500, message: '长度在500个字符内', trigger: 'change'}
    ],
    reason: [
      {required: true, message: '其输入申请理由', trigger: 'change'},
      {max: 500, message: '长度在500个字符内', trigger: 'change'}
    ],
    contacter: [
      {required: true, message: '请输入联系人', trigger: 'change'},
      {max: 32, message: '长度在32个字符内', trigger: 'change'}
    ],
    telephone: [
      {required: true, message: '请输入联系电话', trigger: 'change'},
      {
        pattern: /^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$|(^(13[0-9]|15[0|3|6|7|8|9]|18[8|9])\d{8}$)/,
        message: '请输入正确的号码格式，如：025-6487256，15005059587', trigger: 'change'
      }
    ]
  }

  created() {
    this.type = this.$route.params.type;
    if (this.type === 'demander') {
      this.title = '申请成为委托商';
      this.form.applyType = 1;
    } else if (this.type === 'service') {
      this.title = '申请成为服务商';
      this.form.applyType = 2;
    }
  }

  failConfirm() {
    this.formResult = '';
  }

  onSubmit() {
    const form = this.$refs.form as ElForm;
    form.validate((valid: any) => {
      if (valid) {
        this.loading = true;
        const url = process.env.VUE_APP_BACK_URL + '/api/uas/corp-reg-apply/apply';
        axios.post(url, this.form).then((result: any) => {
          const res = result.data;
          if (res && res.code == 0) {
            this.formResult = 'success'
          } else {
            this.formResult = 'fail'
          }
        }).finally(() => {
          this.loading = false;
        })
      } else {
        return false;
      }
    });
  }
}
